import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter, Link } from "react-router-dom";
import { Formik } from "formik";
import { notification, Alert } from "antd";

import * as Yup from "yup";

/* Styles */
import {
  Wrapper,
  Container,
  RegisterContainer,
  FormContainer,
  DisplayContainer,
  DisplayBody,
  DisplayBodyMessage,
  LogoContainer,
  ButtonCustom,
} from "./styles";

/* Components */
import InputStandard from "../../components/utils/input";
import ArrowIcon from "../../components/utils/icons/arrows/red/left";
import DrawerChangePassword from "../../components/drawers/changePassword";

/* Images */
import LogoVertical from "../../components/login/logos/logoVertical";

/* Redux Actions */
import { Creators as UserActions } from "../../store/ducks/user";
import { verifyExistsUserByEmail } from "../../services/changePasswordService";

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      form: {
        email: "",
        id: "",
      },
      verifyEmail: false,
      errorEmail: false,
    };
  }

  openCloseMenu = () => this.setState({ menuOpen: !this.state.menuOpen });

  openDrawer = () => {
    const { userActions } = this.props;
    userActions.showDrawerChangePassword();
  };

  handleGenerateCode = async (values, actions) => {
    const { email } = values;

    try {
      const res = await verifyExistsUserByEmail(email);
      this.setState({
        form: {
          email,
          id: res.data.results,
        },
      });
      const { translation } = this.props.app;
      notification.success({
        message: translation.changePassword.messages.codeSent,
      });
      this.openDrawer();
    } catch (e) {
      const { translation } = this.props.app;
      if (e.response.status === 404) {
        this.setState({
          errorEmail: true,
        });
      } else {
        notification.error({
          message: translation.changePassword.messages.somethingWentWrong,
        });
      }
    }
  };

  render() {
    const { form, errorEmail } = this.state;
    const { translation } = this.props.app;
    const validationSchema = Yup.object().shape({
      email: Yup.string()
        .email("Digite um e-mail válido")
        .required("É preciso informar um e-mail"),
    });

    return (
      <Wrapper>
        <span className="logo-vertical">
          <LogoVertical />
        </span>
        <Container>
          <RegisterContainer>
            <LogoContainer>
              <LogoVertical />
            </LogoContainer>
            <DisplayBodyMessage>
              <span>
                {translation.common.marketingTagline}
              </span>
            </DisplayBodyMessage>
          </RegisterContainer>
          <DisplayContainer>
            <DisplayBody>
              <FormContainer>
                <Link className="back-container" to="/">
                  <ArrowIcon />
                  <span className="back">{translation.changePassword.back}</span>
                </Link>
                <span className="title">{translation.changePassword.title}</span>
                <span className="subTitle">
                  {translation.changePassword.subtitle}
                </span>
                <Formik
                  initialValues={form}
                  onSubmit={this.handleGenerateCode}
                  validationSchema={validationSchema}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    ...props
                  }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                      <label>{translation.changePassword.registrationEmail}</label>
                      <InputStandard
                        className="input"
                        width="100%"
                        border={
                          !touched.email
                            ? "normal"
                            : errors.email
                            ? "error"
                            : "success"
                        }
                      >
                        <input
                          type="email"
                          value={values?.email}
                          placeholder={translation.changePassword.placeholder}
                          autoCapitalize="off"
                          name="email"
                          onBlur={handleBlur}
                          onChange={(e) =>
                            props.setFieldValue(
                              "email",
                              e.target.value.toLowerCase()
                            )
                          }
                        />
                      </InputStandard>

                      <div className="formFooter">
                        <ButtonCustom type="submit">
                          {translation.changePassword.submitButton}
                        </ButtonCustom>
                      </div>
                    </form>
                  )}
                </Formik>
              </FormContainer>
              <div className={errorEmail ? "" : "hide"}>
                <Alert
                  message={translation.changePassword.emailNotRegistered}
                  type="error"
                  showIcon
                  closable
                  style={{
                    width: 495,
                    marginTop: 35,
                  }}
                />
              </div>
            </DisplayBody>
          </DisplayContainer>
        </Container>
        <DrawerChangePassword formData={form} />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  app: state.app,
});

const mapDispatchToProps = (dispatch) => ({
  userActions: bindActionCreators(UserActions, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
);
